import React, {createRef} from 'react';
import "./index.scss";
import shareImg from "./img/PC0-0.png";
import img1_1 from "./img/PC1-1.jpg";
import img1_2 from "./img/1-1.jpg";
import img2_1 from "./img/PC2-1.jpg";
import img2_2 from "./img/PC3-1.jpg";
import img4_1 from "./img/PC4-1.jpeg";
import img4_2_1 from "./img/PC4-2-1.jpg";
import img4_2_2 from "./img/PC4-2-2.jpg";
import img4_3_1 from "./img/PC4-3-1.jpg";
import img4_3_2 from "./img/PC4-3-2.jpg";
import img4_4 from "./img/Pc4-4.jpeg";
import img4_5_1 from "./img/PC4-5-1.jpg";
import img4_5_2 from "./img/PC4-5-2.jpg";
import img4_6_1 from "./img/PC4-6-1.jpg";
import img4_6_2 from "./img/PC4-6-2.jpg";
import img5_1 from "./img/PC5-1.jpg";
import img5_2 from "./img/PC5-2.jpg";
import img5_3 from "./img/PC5-3.jpg";
import img5_4 from "./img/PC5-4.jpg";
import img5_5 from "./img/PC5-5.jpg";
import img6_1 from "./img/PC6-1.jpg";
import img6_2 from "./img/PC6-2.jpg";
import img6_3 from "./img/PC6-3.jpg";
import img6_4 from "./img/PC6-4.jpg";
import img6_5 from "./img/PC6-5.jpg";
import img6_6 from "./img/PC6-6.jpg";
import title_1 from "./img/PC5-logo.png";
import title_2 from "./img/PC6-logo.png";
import Card from "../Card";
import CardReview from "../CardReview";
import Carousel from "../Carousel";
import CardOverlay from "../CardOverlay";
import CardInfo from "../CardInfo";
import Header from "../Header";


class App extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      headerHeight: null
    };
    this._header = createRef();
    this.updateHeaderHeight = this.updateHeaderHeight.bind(this);
    this.FBShare = this.FBShare.bind(this);
  }
  updateHeaderHeight() {
    this.setState({
      headerHeight: this._header.current.clientHeight
    });
  }
  componentDidMount() {
    this.updateHeaderHeight();
    window.addEventListener('resize', this.updateHeaderHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeaderHeight);
  }
  FBShare() {
    window.FB.ui({
      method: 'share',
      href: 'http://samsungevents2020.mombaby.com.tw',
    }, function(response){});
  }
  render() {
    let section1Content, section2Content, section3Content;
    section1Content = cards_1.map((card, i) => {
      return (
        <div key={i} className="col-12 col-md-6">
          <CardOverlay id={`section1-${i + 1}`} post={card}/>
        </div>
      );
    });
    section2Content = [];
    for (let i = 0; i < cards_2_1.length; i++) {
      let _row = [];
      _row.push(
        <div key={`${i}-0`} className="area-1 area">
          <Card post={cards_2_1[i]}/>
        </div>
        );
      cards_2_2[i].forEach((card, j) => {
        _row.push(
          <div key={`${i}-${j + 1}`} className="area">
            <CardReview post={card}/>
          </div>
          );
      });
      section2Content.push(<div key={i} className="inner col-12">{_row}</div>);
    }
    section3Content = cards_3.map((item, i) => {
      return (
        <div key={i} className="no-gutter row">
          <div className="col-12 col-md-8">
            <Carousel pictures={item.carousel}/>
          </div>
          <div className="col-12 col-md-4">
            <CardInfo post={item}/>
          </div>
        </div>
      )
    });
    return (
      <>
        {/*<button className="fixed-btn" onClick={this.FBShare}><img src={shareImg} alt="share"/></button>*/}
        <Header _header={this._header} height={this.state.headerHeight}/>
        <main className="main">
          <div id="kvAd" style={{marginTop: this.state.headerHeight}}>
            <picture className="img-frame">
              <source srcSet={img1_1} media="(min-width: 768px)"/>
              <img src={img1_2} alt="主視覺圖片"/>
            </picture>
            <div className="inner">
              <hgroup>
                <h1>
                  <small>Air purifier</small>
                  空汙世代
                </h1>
                <h2>
                  我<strong>不</strong>要再當<strong>過敏兒</strong>
                </h2>
              </hgroup>
            </div>

          </div>
          <section id="section1" className="section-1 section">
            <div className="container">
              <div className="row">
                {section1Content}
              </div>
            </div>
          </section>
          <section id="section2" className="section-2 section">
            <div className="container">
              <h2 className="section-title">面對過敏原媽媽們的因應之道</h2>
              <div className="no-gutter row">
                {section2Content}
              </div>
            </div>
          </section>
          <section id="section3" className="section-3 section">
            <h2 className="section-title">抗過敏．必備工具</h2>
            {section3Content}
          </section>
        </main>
        <footer className="footer">
          <p className="copyright">Copyright 2020.媽媽寶寶 All rights reserved.版權所有，禁止擅自轉貼節錄</p>
        </footer>
      </>
    )
  }
}

export default App;


// 主視覺下過敏原因與影響
const cards_1 = [
  {
    title: '揪出居家環境中的過敏原．降低誘發寶寶過敏發作',
    subtitle: '過敏，可說是現代人的文明病！',
    text: '造成過敏的因素很多，最重要的兩個因子為「遺傳」 與 「環境」，先天的「遺傳」體質無法改變、但後天的「環境」則能以人為力量著手改善，最能使力的地方就是居家環境！',
    img: img2_1,
    link: "https://www.mombaby.com.tw/articles/9917149"
  },
  {
    title: '過敏．大大影響幼兒的健康　雖無法根治但可好好控制',
    subtitle: '家有過敏兒，照顧上總令父母燒腦！',
    text: '當症狀發作時，除了不舒服，還會干擾睡眠，而睡不好又會對健康造成許多不良影響，讓父母更加憂心。然而，若能聽從醫囑，即使疾病不能根治，也能在控制良好的狀態下，如常過生活。',
    img: img2_2,
    link: "https://www.mombaby.com.tw/articles/9917148"
  }
];
// 面對過敏原媽媽們的因應之道
const cards_2_1 = [
  {
    title: '如何運用科技照護家中過敏兒．主播媽咪及三胞胎媽咪說給你聽',
    text: '面對過敏兒愈來愈多的現實，該怎麼挑選「給力」又聰明的空氣清淨機和吸塵器，就讓張宇和三胞胎-三寶飯X柴犬哥哥的日常分享搶先體驗Samsung的心得吧！',
    img: {
      sm: img4_1,
      lg: img4_1
    },
    link: "https://www.mombaby.com.tw/articles/9917236"
  },
  {
    title: '完美清潔居家環境神器．優格姊姊與日日·甜甜的科技體驗',
    text: '家庭主婦總想好好把家裡打掃乾淨，讓大家吸到清新的空氣，可是有時並無法只靠主婦的用心，還需要借助清掃神器的力量，而這份神力就是來自三星科技的加持！',
    img: {
      sm: img4_4,
      lg: img4_4
    },
    link: "https://www.mombaby.com.tw/articles/9917238"
  }
];

const cards_2_2 = [
  [
    {
      avatar: img4_2_1,
      title: '主播張宇 讚嘆科技的力量',
      text: '上次老劉回家第一件事就說，剛剛是烤牛排嗎？我：你怎麼知道（驚）。老劉：整個客廳都是牛排味…。連蹦跳身上都是耶！糗…',
      img: img4_2_2,
      link: "https://www.facebook.com/iyufool/posts/1647615962070823?__xts__%5B0%5D=68.ARA3CBeOW42Ldlmlwg2XjlSabQ4lvWkvQ3NjOK9_xYlqj8MoHCwToq9cP05zv7PuC2fJBcQ9HCpM7g1hDOnw8JzNNjo6Enm_mkkXzj6foZ1RxwKD9NppOgVF9j48Vv2aMf4XEvJQoydceA0-Rzjwj5th1xlBa1BDPYsI-5l1Fulb-S7b9U4ylSgxP06njjVhw4ClmJobIYcZOxnbyl9eLjXR-Iw-9FYcNvb1YJ4CYK-8wNF6iDh5rnnGsREkLszEXKVzwubZvoNLTGp1KtLolVqpi1-EsSMxDV-r1nDY0st9b4KBxmSn54EzDfHDTjOFoTtUL6o0XtQcYjvLr0fbLEk0vw&__tn__=-R"
    },
    {
      avatar: img4_3_1,
      title: '三胞胎媽咪 日常打掃其實是一種享受',
      text: '你們家一天都吸塵幾次呢？我們因為家裡有寵物+三個過敏兒，一天基本都是早晚各吸塵一次…',
      img: img4_3_2,
      link: "https://www.facebook.com/lucaNtriplets/posts/3501329893222709?__xts__[0]=68.ARBhBUF56S9YchbWS0AF_tx3NUPyOzCaO66CQ5TLNNhdWwttTQVzucF9HI5RogTihZEilJNiQwKiyDlo29CtwWY5-hDiloIp-816BFbparMvwKthgFb60iBBNa9v8dqiGvG1wGIrYBKWuhU5fiu9n4N0qvCMQlsFlvxprGaZBNRy0Xg5r3V-seb8LAm41_PgzbgP46PHF28OXQ2If0EvpKFG0FMCauWg2CqyRSrqfus1lcsMWli5Zm_6j4avU6R32bT038U_V9GMJZBW-I_g13jbGjMHrefv9gdJeWgojgmMtCjkU8w6pEdbM4pVN7ECUjyZDHhLi6Wa4l_Tga9MKbQ1hw&__tn__=-R"
    }
  ],
  [
    {
      avatar: img4_5_1,
      title: '優格 完美幫手就靠它',
      text: '想維持家裡的整潔真的需要找一個方便又功能強大的好幫手！家裡寵物毛整理起來很麻煩？家人容易過敏？吸個地板腰痠背痛？…',
      img: img4_5_2,
      link: "https://www.facebook.com/doremi.sister/posts/5220501841300643?__xts__[0]=68.ARCe3QsW8d0IpR4QFhIPgWG5Iuxq7kiEStXnnrcBG5W6rrXJNwvg9j310GDglREd7MfUCrnaQn0NOomAIipH9Vbf0b7kuozMJzVGJhc7a5PqpyV3ssj7cREqyhfG0KlGzKx5sEV34XD6V_03OXYujAsOfmIYZ0OSB7VIEeY7s1qiTN9yuiE5ypfsZhxYyrQUyqxkK0FG_RJSGVQNY4h-A6h_DQ5C1a_PYtsfFOKv005VQoky6BjDjvdqwbGxahbRKii05t-7T7YVA7ScOfCnvKodndUDn08k88Re4qWINNykg7TjXWISJnWU-FNPEWF398LL4zGwb6wgefSvOLenaa2-qw&__tn__=-R"
    },
    {
      avatar: img4_6_1,
      title: '日日·甜甜 期許擁有「小豆腐」',
      text: '和女兒的兩人生活，這個月在台北重新開始！我們落腳處是個小小陽光屋，雖然不大卻明亮溫馨，整個家都是甜甜圈的爬爬探索樂園…',
      img: img4_6_2,
      link: "https://www.facebook.com/frenchbullsinba/posts/4123980734295772?__xts__[0]=68.ARDaXYiCHEPWKh3FcowQ_LNnXYSCnbbdF8DaiJ3T-OzWs-TecX4S17cq7K5SzdqrnLoDPhkt84flmUX1QiYf5wSvwI-cdOG1wL8sqnNj1mQwlir0v0zhANvLCLhYs6Gv6IdEQqxnzDBUrQjFkfQdV4-iwanvFdQdfV1n21KDwRvaAFLDx3F9cw6wWT-ItEv6zq4S4xpsH4Kl5mQekD79P_1aTjuT2hQiYXaKPceePbF-50fV3DIo3W8v_67DuO-RkqtYbVY0qNurdrlCj6WqB71tlkC2ixtH0fliNkCAlZvC_3gSYi0FB502U_PvhIYGD5tYoeckpD_WUT8HWKfvKQRO1Q&__tn__=-R"
    }
  ]
];

const cards_3 = [
  {
    carousel: [
      img5_1,
      img5_2,
      img5_3,
      img5_4,
      img5_5
    ],
    title : {
      url: title_1,
      alt: "samsung cube 無風智慧清淨機"
    },
    list: [
      `Wind-Free<sup>TM</sup>無風過濾技術`,
      "多層次HEPA濾清系統",
      "智慧遠端控制平台",
      "兒童安全鎖"
    ],
    link: 'https://tinyurl.com/y4bqhwqs'
  },
  {
    carousel: [
      img6_1,
      img6_2,
      img6_3,
      img6_4,
      img6_5,
      img6_6
    ],
    title : {
      url: title_2,
      alt: "samsung jet 無線變頻吸塵器"
    },
    list: [
      "極吸力噴射氣旋/數位變頻馬達",
      "多層次立架及額外充電座",
      "人體工學匣持久使用強勁吸力",
      "LED資訊顯示",
      "可更換電池HEPA濾清系統"
    ],
    link: 'https://tinyurl.com/yxd6zwml'
  }
];
